//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('collectionMenu', {
//        templateUrl: 'views/components/views/collectionMenu/collectionMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'collectionMenuService', function ($stateParams, stateService, modalService, translateService, collectionMenuService) {
//            const vm = this;
//            let collectionKeyno = $stateParams.collection_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                collectionKeyno: collectionKeyno,
//                collectionNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('collectionlangs', { collection_keyno: vm.model.menu.collection_keyno }) }
//                ],
//                menu: {},
//                lockedDelete: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadMenu() {
//                vm.model.menu = (await collectionMenuService.getMenu({ collection_keyno: collectionKeyno }))[0];
//            }

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    collectionMenuService.deleteItem({ collection_keyno: vm.model.menu.collection_keyno }).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            vm.$onInit = async function () {
//                translate();
//                loadMenu();
//            }
//        }]
//    });
//})();
